<template>
  <div class="div">
    <div class="div-top">
      <div>
        <!-- <span class="label">分析选项:</span>
        <el-radio-group v-model="searchData.SortType" @change="getDataList">
          <el-radio-button label="Amount">
            <i class="icon icon-rmb1" style="font-size: 14px"></i>
            金额分析</el-radio-button
          >
          <el-radio-button label="Qty">
            <i class="icon icon-num" style="font-size: 14px"></i>
            用量分析</el-radio-button
          >
        </el-radio-group> -->
        <!-- <span class="label">分类选项:</span>
        <el-radio-group v-model="searchData.SortType" @change="getDataList">
          <el-radio-button label="Building">楼栋分类</el-radio-button>
          <el-radio-button label="DeviceType">设备分类</el-radio-button>
        </el-radio-group> -->
        <span class="label">时间选项:</span>
        <el-radio-group v-model="searchData.TimeType" @change="timeTypeChange">
          <el-radio-button label="YearMonth">年月</el-radio-button>
          <el-radio-button label="Year">年份</el-radio-button>
        </el-radio-group>
        <div v-if="searchData.TimeType === 'Year'" style="display: inline-block">
          <span class="label">选择年份:</span>

          <el-date-picker
            v-model="searchData.StartTimeYear"
            type="year"
            :picker-options="startYearOptions"
            placeholder="选择年份"
            value-format="yyyy"
            style="width: 150px; text-align: center"
            :clearable="false"
            @change="getDataList"
          >
          </el-date-picker>
          <span class="separator">至</span>
          <el-date-picker
            v-model="searchData.EndTimeYear"
            type="year"
            placeholder="结束年份"
            :picker-options="endYearOptions"
            value-format="yyyy"
            :clearable="false"
            @change="getDataList"
            style="width: 150px; text-align: center"
          >
          </el-date-picker>
        </div>
        <div v-if="searchData.TimeType === 'YearMonth'" style="display: inline-block">
          <span class="label">选择年月:</span>
          <el-date-picker
            v-model="searchData.searchYear"
            :picker-options="monthRangeOptions"
            type="monthrange"
            :clearable="false"
            range-separator="至"
            value-format="yyyyMM"
            start-placeholder="开始月份"
            end-placeholder="结束月份"
            @change="getDataList"
          >
          </el-date-picker>
        </div>
      </div>
      <div class="search-item" v-loading="buildingLoading">
        <div class="label">选择楼栋分类:</div>
        <el-checkbox-group v-model="searchData.Buildings" @change="BuildingsListChange">
          <el-checkbox
            v-for="item in BuildingsList"
            :key="item.Id"
            :label="item.Id"
            :disabled="item.disabled"
            >{{ item.Name }}</el-checkbox
          >
        </el-checkbox-group>
      </div>
      <div class="search-item" v-loading="deviceTypeLoading">
        <div class="label">选择设备分类:</div>
        <el-checkbox-group
          v-model="searchData.DeviceTypes"
          @change="DeviceTypesListChange"
        >
          <el-checkbox
            v-for="item in DeviceTypesList"
            :key="item.Id"
            :label="item.Id"
            :disabled="item.disabled"
            >{{ item.DicName }}</el-checkbox
          >
        </el-checkbox-group>
      </div>
    </div>
    <div class="dom-card" style="margin-top: 10px" v-loading="loading">
      <div class="dom-card-title">工单情况分析</div>
      <div class="df aic w100" style="margin-top: 10px">
        <div class="df" style="width: 70%; gap: 5px">
          <EchartsDom
            v-for="item in workOrderList?.totalpiechart || []"
            :key="item.name"
            type="pie"
            :data="item.value"
            :title="item.name"
            :showLegend="false"
            :labelOption="{
              formatter: (params) => {
                return params.value && params.value !== 0
                  ? `${params.name}:  ${params.percent}%`
                  : '';
              },
            }"
            width="25%"
            height="200px"
            :style="'border-right: 1px solid #ccc'"
          >
          </EchartsDom>
        </div>
        <div style="width: 30%; min-width: 400px">
          <div class="class-table">
            <div class="class-tableItem" v-if="workOrderList?.slist?.length > 0">
              <div class="class-tableItem-title">状态</div>
              <div class="class-tableItem-content">
                <div class="class-tableItem-content-item">完成</div>
              </div>
              <div class="class-tableItem-content">
                <div class="class-tableItem-content-item">进行中</div>
              </div>
              <div class="class-tableItem-content">
                <div class="class-tableItem-content-item">未分配</div>
              </div>
              <div class="class-tableItem-content">
                <div
                  class="class-tableItem-content-item"
                  style="font-weight: bold; font-size: 14px"
                >
                  总量
                </div>
              </div>
            </div>
            <div
              class="class-tableItem"
              v-for="item in workOrderList.slist || []"
              :key="item.name"
            >
              <div class="class-tableItem-title">
                {{ item.name }}
              </div>
              <div class="class-tableItem-content">
                <div class="class-tableItem-content-item">
                  {{ item.list.xjNums || 0 }}
                </div>
              </div>
              <div class="class-tableItem-content">
                <div class="class-tableItem-content-item">
                  {{ item.list.bjNums || 0 }}
                </div>
              </div>
              <div class="class-tableItem-content">
                <div class="class-tableItem-content-item">
                  {{ item.list.wxNums || 0 }}
                </div>
              </div>
              <div class="class-tableItem-content">
                <div
                  class="class-tableItem-content-item"
                  style="font-weight: bold; font-size: 14px"
                >
                  {{ item.list.Nums || 0 }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="dom-card" style="margin-top: 10px" v-loading="loading">
      <div class="dom-card-title df aic jub">
        <div style="width: 50%">
          <span>A1.按楼栋工单分布</span>
          <span class="hint-text"> </span>
        </div>
        <div style="width: 50%; padding-left: 20px">
          <span>B1.按专业设备工单分布</span>
          <span class="hint-text"> </span>
        </div>
      </div>
      <div class="Table-List cpad">
        <el-table
          :data="workOrderList.blist"
          style="width: 50%; min-height: 240px"
          header-row-class-name="table-tit"
          row-class-name="table-row"
        >
          <el-table-column prop="TypeName" align="center" label="楼栋"> </el-table-column>
          <el-table-column prop="state" align="center" label="状态">
            <template slot-scope="{ row }">
              <div
                v-for="(item, index) in row?.state || []"
                :key="item"
                style="justify-content: center"
                :class="['table-content', index === row?.state?.length - 1 ? '' : 'bot1']"
              >
                {{ item }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="xjNums" align="right" label="巡检">
            <template slot-scope="{ row }">
              <div
                v-for="(item, index) in row?.xjNums || []"
                :key="JSON.stringify(item)"
                :class="[
                  'table-content',
                  index === row?.xjNums?.length - 1 ? '' : 'bot1',
                ]"
              >
                {{ item.value }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="bjNums" align="right" label="保养">
            <template slot-scope="{ row }">
              <div
                v-for="(item, index) in row?.bjNums || []"
                :key="JSON.stringify(item)"
                :class="[
                  'table-content',
                  index === row?.bjNums?.length - 1 ? '' : 'bot1',
                ]"
              >
                {{ item.value }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="wxNums" align="right" label="维修">
            <template slot-scope="{ row }">
              <div
                v-for="(item, index) in row?.wxNums || []"
                :key="JSON.stringify(item)"
                :class="[
                  'table-content',
                  index === row?.wxNums?.length - 1 ? '' : 'bot1',
                ]"
              >
                {{ item.value }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="Nums" align="right" label="总数">
            <template slot-scope="{ row }">
              <div
                v-for="(item, index) in row?.Nums || []"
                :key="JSON.stringify(item)"
                :class="['table-content', index === row?.Nums?.length - 1 ? '' : 'bot1']"
              >
                {{ item.value }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="Nums" align="center" label="统计" width="300">
            <template slot-scope="{ row }">
              <EchartsDom
                type="bar2"
                :data="row?.echartsData || []"
                width="100%"
                height="150px"
                :showLegend="false"
                :grid="{
                  top: 30,
                  left: 60,
                  bottom: 30,
                  right: 10,
                }"
                barMaxWidth="20px"
              >
              </EchartsDom>

              <!-- <div
                class="table-content"
                v-for="item in row?.Nums || []"
                :key="JSON.stringify(item)"
              >
                {{ item.value }}
              </div> -->
            </template>
          </el-table-column>
        </el-table>
        <el-divider direction="vertical" class="divider"></el-divider>
        <el-table
          :data="workOrderList.tlist"
          style="width: 50%; min-height: 240px"
          header-row-class-name="table-tit"
          row-class-name="table-row"
        >
          <el-table-column prop="TypeName" align="center" label="设备分类">
          </el-table-column>
          <el-table-column prop="state" align="center" label="状态">
            <template slot-scope="{ row }">
              <div
                v-for="(item, index) in row?.state || []"
                :key="item"
                style="justify-content: center"
                :class="['table-content', index === row?.state?.length - 1 ? '' : 'bot1']"
              >
                {{ item }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="xjNums" align="right" label="巡检">
            <template slot-scope="{ row }">
              <div
                v-for="(item, index) in row?.xjNums || []"
                :key="JSON.stringify(item)"
                :class="[
                  'table-content',
                  index === row?.xjNums?.length - 1 ? '' : 'bot1',
                ]"
              >
                {{ item.value }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="bjNums" align="right" label="保养">
            <template slot-scope="{ row }">
              <div
                v-for="(item, index) in row?.bjNums || []"
                :key="JSON.stringify(item)"
                :class="[
                  'table-content',
                  index === row?.bjNums?.length - 1 ? '' : 'bot1',
                ]"
              >
                {{ item.value }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="wxNums" align="right" label="维修">
            <template slot-scope="{ row }">
              <div
                v-for="(item, index) in row?.wxNums || []"
                :key="JSON.stringify(item)"
                :class="[
                  'table-content',
                  index === row?.wxNums?.length - 1 ? '' : 'bot1',
                ]"
              >
                {{ item.value }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="Nums" align="right" label="总数">
            <template slot-scope="{ row }">
              <div
                v-for="(item, index) in row?.Nums || []"
                :key="JSON.stringify(item)"
                :class="['table-content', index === row?.Nums?.length - 1 ? '' : 'bot1']"
              >
                {{ item.value }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="Nums" align="center" label="统计" width="300">
            <template slot-scope="{ row }">
              <EchartsDom
                type="bar2"
                :data="row?.echartsData || []"
                width="100%"
                height="150px"
                :showLegend="false"
                :grid="{
                  top: 30,
                  left: 60,
                  bottom: 30,
                  right: 10,
                }"
                barMaxWidth="20px"
              >
              </EchartsDom>

              <!-- <div
                class="table-content"
                v-for="item in row?.Nums || []"
                :key="JSON.stringify(item)"
              >
                {{ item.value }}
              </div> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div
      class="dom-card"
      style="margin-top: 10px"
      v-loading="workOrderTimeLoading || workOrderTimeLoading2"
    >
      <div class="dom-card-title df aic jub">
        <div style="width: 50%" class="df aic jub">
          <span>A2.按楼栋工单耗时统计</span>
          <span class="hint-text"> （从派单到完工用时） </span>
        </div>
        <div style="width: 50%; padding-left: 20px" class="df aic jub">
          <span>B2.按专业设备工单耗时统计</span>
          <span class="hint-text"> （从派单到完工用时） </span>
        </div>
      </div>
      <div class="Table-List">
        <el-table
          :data="workOrderTimeList"
          style="width: 50%; min-height: 240px"
          v-loading="workOrderTimeLoading"
        >
          <el-table-column prop="TypeName" align="center" label="楼栋"> </el-table-column>

          <el-table-column prop="xjNums" align="right" label="巡检工单（小时）">
          </el-table-column>
          <el-table-column prop="bjNums" align="right" label="保养工单（小时）">
          </el-table-column>
          <el-table-column prop="wxNums" align="right" label="维修工单（小时）">
          </el-table-column>
          <el-table-column prop="Nums" align="right" label="平均用时（小时）">
          </el-table-column>
        </el-table>
        <el-divider direction="vertical" class="divider"></el-divider>
        <el-table
          :data="workOrderTimeList2"
          style="width: 50%; min-height: 240px"
          v-loading="workOrderTimeLoading2"
        >
          <el-table-column prop="TypeName" align="center" label="设备分类">
          </el-table-column>

          <el-table-column prop="xjNums" align="right" label="巡检工单（小时）">
          </el-table-column>
          <el-table-column prop="bjNums" align="right" label="保养工单（小时）">
          </el-table-column>
          <el-table-column prop="wxNums" align="right" label="维修工单（小时）">
          </el-table-column>
          <el-table-column prop="Nums" align="right" label="平均用时（小时）">
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div
      class="dom-card"
      style="margin-top: 10px"
      v-loading="workOrderAreaLoading || workOrderDeviceLoading"
    >
      <div class="dom-card-title df aic jub">
        <div style="width: 50%" class="df aic jub">
          <span>A3.按楼栋面积工作负荷密度统计</span>
          <span class="hint-text"> （次数/每平米） </span>
        </div>
        <div style="width: 50%; padding-left: 20px" class="df aic jub">
          <span>B3.按专业设备工作负荷密度统计</span>
          <span class="hint-text"> （次数/设备量） </span>
        </div>
      </div>

      <div class="Table-List">
        <el-table
          :data="workOrderAreaList"
          style="width: 50%; min-height: 240px"
          v-loading="workOrderAreaLoading"
        >
          <el-table-column prop="TypeName" align="center" label="楼栋"> </el-table-column>
          <el-table-column prop="Nums" align="right" label="面积"> </el-table-column>
          <el-table-column prop="xjNums" align="right" label="巡检负荷">
          </el-table-column>
          <el-table-column prop="bjNums" align="right" label="保养负荷">
          </el-table-column>
          <el-table-column prop="wxNums" align="right" label="维修负荷">
          </el-table-column>
        </el-table>
        <el-divider direction="vertical" class="divider"></el-divider>
        <el-table
          :data="workOrderDeviceList"
          style="width: 50%; min-height: 240px"
          v-loading="workOrderDeviceLoading"
        >
          <el-table-column prop="TypeName" align="center" label="设备分类">
          </el-table-column>
          <el-table-column prop="Nums" align="right" label="设备量"> </el-table-column>
          <el-table-column prop="xjNums" align="right" label="巡检负荷">
          </el-table-column>
          <el-table-column prop="bjNums" align="right" label="保养负荷">
          </el-table-column>
          <el-table-column prop="wxNums" align="right" label="维修负荷">
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div style="height: 20px"></div>
  </div>
</template>
<script>
import moment from "moment";

import EchartsDom from "@/components/EchartsDom/EchartsDom.vue";
export default {
  data() {
    return {
      searchData: {
        SortType: "Building",
        TimeType: "YearMonth",

        StartTime: "",
        EndTime: "",
        DeviceTypes: [],
        Buildings: [],
        searchYear: [],
        StartTimeYear: "",
        EndTimeYear: "",
      },
      loading: false,
      deviceTypeLoading: false,
      buildingLoading: false,
      debouncedGetDataList: null,
      BuildingsList: [],
      DeviceTypesList: [],
      workOrderList: {},
      workOrderTimeLoading: false,
      workOrderTimeLoading2: false,

      workOrderTimeList: [],
      workOrderTimeList2: [],
      workOrderAreaLoading: false,
      workOrderDeviceLoading: false,
      workOrderAreaList: [],
      workOrderDeviceList: [],

      spanArr: [], // 用于存储 blist 合并行信息
      spanArrTlist: [], // 用于存储 tlist 合并行信息
      monthRangePicking: { minDate: null, maxDate: null },
    };
  },
  props: {},
  components: { EchartsDom },
  methods: {
    classTypeChange() {
      if (this.searchData.classType == "bui") {
        this.searchData.Buildings = this.BuildingsList.map((item) => item.Id);
      } else if (this.searchData.classType == "dev") {
        this.searchData.DeviceTypes = this.DeviceTypesList.map((item) => item.Id);
      }
    },
    timeTypeChange() {
      if (this.searchData.TimeType === "Year") {
        if (!this.searchData.StartTimeYear || this.searchData.EndTimeYear) {
          this.searchData.StartTimeYear = moment().format("YYYY");
          this.searchData.EndTimeYear = moment().format("YYYY");
        }
      } else if (this.searchData.TimeType === "YearMonth") {
        this.searchData.searchYear = [
          moment().startOf("year").format("YYYYMM"),
          moment().endOf("year").format("YYYYMM"),
        ];
      }
      this.getDataList();
    },
    DeviceTypesListChange(a) {
      console.log(a);
      if (a.length === 1) {
        this.DeviceTypesList.find((item) => item.Id === a[0]).disabled = true;
      } else {
        this.DeviceTypesList.forEach((item) => {
          item.disabled = false;
        });
      }
      this.debouncedGetDataList();
    },
    BuildingsListChange(a) {
      console.log(a);
      if (a.length === 1) {
        this.BuildingsList.find((item) => item.Id === a[0]).disabled = true;
      } else {
        this.BuildingsList.forEach((item) => {
          item.disabled = false;
        });
      }

      this.debouncedGetDataList();
    },
    //获取楼栋列表
    async getBuildingDataList() {
      this.buildingLoading = true;
      await this.$http
        .post("/PB/PB_Project/GetProjectBuildingDataList", {})
        .then((res) => {
          this.buildingLoading = false;
          if (res.Success) {
            this.BuildingsList = res.Data || [];
            this.BuildingsList.forEach((item) => {
              this.$set(item, "disabled", false);
            });
            this.searchData.Buildings = this.BuildingsList.map((item) => item.Id);
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
    async getProjectDeviceTypeList() {
      this.deviceTypeLoading = true;
      await this.$http.post("/PB/PB_Project/GetDevcieDictionaryMain", {}).then((res) => {
        this.deviceTypeLoading = false;
        if (res.Success) {
          this.DeviceTypesList = res.Data || [];
          this.DeviceTypesList.forEach((item) => {
            this.$set(item, "disabled", false);
          });
          this.searchData.DeviceTypes = this.DeviceTypesList.map((item) => item.Id);
        } else {
          this.$notify.error(res.Msg);
        }
      });
    },
    getDataList() {
      if (this.searchData.TimeType === "Year") {
        this.searchData.StartTime = this.searchData.StartTimeYear;
        this.searchData.EndTime = this.searchData.EndTimeYear;
      } else if (this.searchData.TimeType === "YearMonth") {
        this.searchData.StartTime = this.searchData.searchYear[0];
        this.searchData.EndTime = this.searchData.searchYear[1];
      }
      this.getWorkOrderList();
      this.getWorkOrderTimeList();
      this.getWorkOrderAreaList();
      this.getWorkOrderDeviceList();
    },
    async getWorkOrderList() {
      this.loading = true;
      this.$http
        .post("/PB/PB_Project/GetWorkOrderDistributionAnalysis", {
          // SortType: this.searchData.SortType,
          TimeType: this.searchData.TimeType,
          StartTime: this.searchData.StartTime,
          EndTime: this.searchData.EndTime,
          DeviceTypes: this.searchData.DeviceTypes.join(","),
          Buildings: this.searchData.Buildings.join(","),
        })
        .then((res) => {
          this.loading = false;
          if (res.Success) {
            this.workOrderList = res.Data || {};
            // 计算合并行信息
            this.calculateSpanArr();
            this.calculateSpanArrTlist();
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
    getWorkOrderTimeList() {
      this.workOrderTimeLoading = true;
      this.$http
        .post("/PB/PB_Project/GetWorkOrderDistributionHoursAnalysis", {
          SortType: "Building",

          TimeType: this.searchData.TimeType,
          StartTime: this.searchData.StartTime,
          EndTime: this.searchData.EndTime,
          DeviceTypes: this.searchData.DeviceTypes.join(","),
          Buildings: this.searchData.Buildings.join(","),
        })
        .then((res) => {
          this.workOrderTimeLoading = false;
          if (res.Success) {
            this.workOrderTimeList = res.Data || [];
          } else {
            this.$notify.error(res.Msg);
          }
        });
      this.workOrderTimeLoading2 = true;
      this.$http
        .post("/PB/PB_Project/GetWorkOrderDistributionHoursAnalysis", {
          SortType: "DeviceType",
          TimeType: this.searchData.TimeType,
          StartTime: this.searchData.StartTime,
          EndTime: this.searchData.EndTime,
          DeviceTypes: this.searchData.DeviceTypes.join(","),
          Buildings: this.searchData.Buildings.join(","),
        })
        .then((res) => {
          this.workOrderTimeLoading2 = false;
          if (res.Success) {
            this.workOrderTimeList2 = res.Data || [];
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
    getWorkOrderAreaList() {
      this.workOrderAreaLoading = true;
      this.$http
        .post("/PB/PB_Project/GetWorkOrderDistributionAreaAnalysis", {
          TimeType: this.searchData.TimeType,
          StartTime: this.searchData.StartTime,
          EndTime: this.searchData.EndTime,
          DeviceTypes: this.searchData.DeviceTypes.join(","),
          Buildings: this.searchData.Buildings.join(","),
        })
        .then((res) => {
          this.workOrderAreaLoading = false;
          if (res.Success) {
            this.workOrderAreaList = res.Data || [];
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
    getWorkOrderDeviceList() {
      this.workOrderDeviceLoading = true;
      this.$http
        .post("/PB/PB_Project/GetWorkOrderDeviceAnalysis", {
          TimeType: this.searchData.TimeType,
          StartTime: this.searchData.StartTime,
          EndTime: this.searchData.EndTime,
          DeviceTypes: this.searchData.DeviceTypes.join(","),
          Buildings: this.searchData.Buildings.join(","),
        })
        .then((res) => {
          this.workOrderDeviceLoading = false;
          if (res.Success) {
            this.workOrderDeviceList = res.Data || [];
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
    calculateSpanArr() {
      // 初始化合并数组
      this.spanArr = [];
      let pos = 0;
      const list = this.workOrderList.blist || [];

      list.forEach((item, index) => {
        if (index === 0) {
          // 第一个元素，记录当前位置
          this.spanArr.push(1);
          pos = 0;
        } else {
          // 判断当前元素的 TypeName 是否和前一个相同
          if (list[index].TypeName === list[index - 1].TypeName) {
            // 相同，合并到上一个位置
            this.spanArr[pos] += 1;
            this.spanArr.push(0);
          } else {
            // 不同，新起一个合并位置
            this.spanArr.push(1);
            pos = index;
          }
        }
      });
    },
    calculateSpanArrTlist() {
      // 初始化 tlist 合并数组
      this.spanArrTlist = [];
      let pos = 0;
      const list = this.workOrderList.tlist || [];

      list.forEach((item, index) => {
        if (index === 0) {
          // 第一个元素，记录当前位置
          this.spanArrTlist.push(1);
          pos = 0;
        } else {
          // 判断当前元素的 TypeName 是否和前一个相同
          if (list[index].TypeName === list[index - 1].TypeName) {
            // 相同，合并到上一个位置
            this.spanArrTlist[pos] += 1;
            this.spanArrTlist.push(0);
          } else {
            // 不同，新起一个合并位置
            this.spanArrTlist.push(1);
            pos = index;
          }
        }
      });
    },
    objectSpanMethod({ rowIndex, columnIndex }) {
      // 第一列（TypeName））进行合并
      if (columnIndex === 0) {
        const rowspan = this.spanArr[rowIndex];
        const colspan = rowspan > 0 ? 1 : 0;
        return {
          rowspan: rowspan,
          colspan: colspan,
        };
      }
      // 其他列不合并
      return {
        rowspan: 1,
        colspan: 1,
      };
    },
    getChartDataByTypeName(typeName) {
      // 获取指定 TypeName 的所有数据用于图表展示
      const list = this.workOrderList.blist || [];
      const filteredData = list.filter((item) => item.TypeName === typeName);

      // 将数据转换为图表所需格式
      // 根据实际的数据结构，可能需要调整这里的转换逻辑
      return filteredData.map((item) => ({
        name: item.State || "未知",
        value: item.Nums || 0,
      }));
    },
    objectSpanMethodTlist({ rowIndex, columnIndex }) {
      // 第一列（TypeName）进行合并
      if (columnIndex === 0) {
        const rowspan = this.spanArrTlist[rowIndex];
        const colspan = rowspan > 0 ? 1 : 0;
        return {
          rowspan: rowspan,
          colspan: colspan,
        };
      }
      // 其他列不合并
      return {
        rowspan: 1,
        colspan: 1,
      };
    },
  },
  mounted() {},
  async created() {
    this.searchData.StartTimeYear = moment().format("YYYY");
    this.searchData.EndTimeYear = moment().format("YYYY");
    this.searchData.searchYear = [
      moment().startOf("year").format("YYYYMM"),
      moment().endOf("year").format("YYYYMM"),
    ];
    this.loading = true;
    await this.getProjectDeviceTypeList();
    await this.getBuildingDataList();
    this.getDataList();
    this.debouncedGetDataList = this.$tools.debounce(function () {
      this.getDataList();
    }, 500);
  },
  computed: {
    monthRangeOptions() {
      return {
        onPick: ({ minDate, maxDate }) => {
          this.monthRangePicking = { minDate, maxDate };
        },
        disabledDate: (time) => {
          const { minDate, maxDate } = this.monthRangePicking || {};
          if (minDate && !maxDate) {
            // 限制最大跨度为12个月（含起始月，共12）
            const diffMonths = Math.abs(moment(time).diff(moment(minDate), "months"));
            return diffMonths > 11;
          }
          return false;
        },
      };
    },
    startYearOptions() {
      return {
        disabledDate: (time) => {
          const year = time.getFullYear();
          // 如果结束年份已选择，开始年份需在 [结束年份-10, 结束年份] 范围内
          if (this.searchData.EndTime) {
            const end = parseInt(this.searchData.EndTime);
            return year > end || year < end - 10;
          }
          return false;
        },
      };
    },
    endYearOptions() {
      return {
        disabledDate: (time) => {
          const year = time.getFullYear();
          // 如果开始年份已选择，结束年份需在 [开始年份, 开始年份+10] 范围内
          if (this.searchData.StartTime) {
            const start = parseInt(this.searchData.StartTime);
            return year < start || year > start + 10;
          }
          return false;
        },
      };
    },
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
.label {
  font-size: 14px;
  font-weight: bold;
  margin-right: 20px;
  margin-left: 10px;
  display: inline-block;
  width: 100px;
  text-align: right;
}
.search-item {
  display: flex;
  align-items: center;
  margin: 10px 0;
  .el-checkbox-group {
    flex: 1;
  }
}
.yearSelect {
  display: flex;
  align-items: center;
  justify-content: center;

  .separator {
    font-size: 12px;
    margin: 0 10px;
  }
}
.table-card {
  flex: 1;

  text-align: right;
  border-bottom: 1px solid #e4e7ed;
  display: flex;
  align-items: center;
  justify-content: right;
  font-size: 14px;
  font-weight: bold;
}
.Table-List {
  display: flex;

  gap: 15px;
  padding: 10px 0;
}
::v-deep .divider {
  height: auto;
}
.class-table {
  width: 100%;
  display: flex;
}
.class-tableItem {
  flex: 1;
  .class-tableItem-title {
    font-size: 14px;
    font-weight: bold;
    height: 40px;
    border-bottom: 1px solid #e4e7ed;
    display: flex;
    align-items: center;
    justify-content: right;
  }
  .class-tableItem-content {
    border-bottom: 1px solid #e4e7ed;
    display: flex;
    align-items: center;
    justify-content: right;
    height: 40px;
    font-size: 12px;
  }
}
.table-content {
  height: 50px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: right;
}
.bot1 {
  border-bottom: 1px solid #e4e7ed;
}
::v-deep .cpad .cell {
  padding: 0;
}
::v-deep .cpad .el-table__cell {
  padding: 0 !important;
}
::v-deep .table-row {
  .el-table__cell {
    border-bottom: 1px solid #9c9898;
  }
}
</style>
